import { Divider, Fade } from '@material-ui/core';
import { Grid, Button } from '@material-ui/core';
import { List as ListMaterial } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import { GroupAddOutlined } from '@material-ui/icons';
import Alert from '@material-ui/lab/Alert';
import CoProducerClass from 'classes/CoProducer';
import Spin from 'components/Spin';
import React, { Component, createRef } from 'react';
import { withRouter } from 'react-router-dom';
import { run } from 'validations/ruleRunner';

import PartnerCardPreview from './components/Card';
import CoProducerForm from './components/CoProducerForm';
import { SolidaritySquadAlert } from './components/SolidaritySquad/Alert';
import { SolidaritySquadForm } from './components/SolidaritySquad/Form';
import Validations from './validations';
import { FormContent } from '../FormContent';
import styles from '../styles';

import type ICoProducer from 'interfaces/ICoProducer';
import type { RouteComponentProps } from 'react-router-dom';

interface IProps extends RouteComponentProps<any> {
  coproducers?: Array<ICoProducer>;
  loading: boolean;
  onChange: Function;
  fade: boolean;
  onChangeRequiredFields?: Function;
  classes?: any;
  canAddCoproducer: boolean;
  coProducerErrorMessage: string;
  hasElevarAdded: boolean;
}

interface IStates {
  validationErrors: any;
  showActive: boolean;
  showPending: boolean;
  showNew: boolean;
}

const DEFAULT_COMMISSION_VALUE = 5;
const PROJECT_ELEVAR_ID = 75879698;
class CoProducer extends Component<IProps, IStates> {
  private listNewRef = createRef<HTMLDivElement>();
  constructor(props: any) {
    super(props);
    this.state = {
      validationErrors: run(props.coproducers, Validations),
      showActive: true,
      showPending: true,
      showNew: true,
    };
  }

  add = () => {
    let newCoproducers: Array<ICoProducer> = this.props.coproducers;
    let newcp = new CoProducerClass({ new: true, pending: false });
    newCoproducers.push(newcp);
    this.props.onChange(newCoproducers);
  };

  scrollToListNew = () => {
    setTimeout(() => {
      this.listNewRef.current?.scrollIntoView();
    }, 0);
  };

  removeCommissionFromProducer(coproducers: ICoProducer[], commissionValue = DEFAULT_COMMISSION_VALUE) {
    return coproducers.map((cop) => {
      if (cop.is_producer) {
        if (typeof cop.comission_value === 'string') {
          cop.comission_value = Number((cop.comission_value as string).replace(',', '.'));
        }
        cop.comission_value -= commissionValue;
        cop.edited = true;
      }
      return cop;
    });
  }

  addElevar = (commissionValue = DEFAULT_COMMISSION_VALUE) => {
    const newCoproducers: Array<ICoProducer> = this.props.coproducers;
    const isElevarAlreadyAdded = newCoproducers.some((cop) => cop.customer_id === PROJECT_ELEVAR_ID);
    if (isElevarAlreadyAdded) {
      this.scrollToListNew();
      return;
    }
    const elevar = new CoProducerClass({
      new: true,
      pending: false,
      business_name: 'Instituto Elevar',
      email: 'contato@projetoelevar.com.br',
      comission_type: 'P',
      comission_value: commissionValue,
      customer_id: PROJECT_ELEVAR_ID,
    });
    const updatedCoproducers = this.removeCommissionFromProducer(newCoproducers, commissionValue);
    this.props.onChange([...updatedCoproducers, elevar]);
    this.scrollToListNew();
  };

  remove = (k: any) => {
    const newCoproducers: Array<ICoProducer> = this.props.coproducers;
    const filtered = newCoproducers.filter((value: any, index: any) => {
      return index !== k;
    });
    this.props.onChange(filtered);
    this.props.onChangeRequiredFields();
  };

  onChange = (field: any, index: any, value: any) => {
    const newCops: Array<ICoProducer> = this.props.coproducers;
    newCops[index][field] = value;
    newCops[index].edited = true;
    this.props.onChange(newCops);
  };

  onSearchSuccess = (index: any, customer: any) => {
    const newCops: Array<ICoProducer> = this.props.coproducers;
    newCops[index].customer_id = customer.id;
    newCops[index].business_name = customer.business_name;
    this.props.onChange(newCops);
  };

  componentDidUpdate() {
    const { coproducers } = this.props;

    if (!(window as any).sumCoproducersComissions) {
      const activeValue: number = coproducers
        .filter((c) => (c.active || c.new) && !c.pending)
        .map((c) => Number(c.comission_value.toString().replace(',', '.')))
        .reduce((v1, v2) => v1 + v2, 0);
      (window as any).sumCoproducersComissions = activeValue;
    }
  }

  render() {
    const { coproducers, classes, loading, onChangeRequiredFields } = this.props;
    const { showActive, showNew, showPending } = this.state;

    if (loading) {
      return (
        <div className={classes.loadingPages}>
          <Spin />
        </div>
      );
    }

    const listCoproducers = coproducers && Array.isArray(coproducers) ? putIndexOnArray(coproducers) : [];
    const listActive = listCoproducers.filter((c) => c.active);
    const listNew = listCoproducers.filter((c) => c.new && !c.pending);
    const listPending = listCoproducers.filter((c) => c.pending);
    const MAX_COMISSION = 100;

    const activeValue: number = listCoproducers
      .filter((c) => (c.active || c.new) && !c.pending)
      .filter((c) => !c.is_producer)
      .map((c) => Number(c.comission_value.toString().replace(',', '.')))
      .reduce((v1, v2) => v1 + v2, 0);

    const producerValue: number = MAX_COMISSION - activeValue;
    const hasActive = listActive.length > 0;
    const hasNew = listNew.length > 0;
    const hasPending = listPending.length > 0;

    const commissionBiggerThanExpected = activeValue > MAX_COMISSION;

    const hasCoproducers = hasActive || hasNew || hasPending;

    const listSavedCoproducers = listActive.map((cop) => {
      const firstComissionsAreDiffThanMax = (window as any).sumCoproducersComissions !== MAX_COMISSION;

      if (cop.is_producer && !firstComissionsAreDiffThanMax) {
        cop.comission_value = commissionBiggerThanExpected ? 0 : producerValue;
      }

      return (
        <Fade in={showActive} key={cop.originalIndex}>
          <Grid item xs={12} md={6}>
            <PartnerCardPreview
              index={cop.originalIndex}
              coproducer={cop}
              disabled={cop.is_producer && !firstComissionsAreDiffThanMax}
              onChangeField={this.onChange}
              onChangeRequiredFields={onChangeRequiredFields}
              onRemove={() => this.remove(cop.originalIndex)}
              isProducer={cop.is_producer}
              onSearchSuccess={this.onSearchSuccess}
              coproducers={listCoproducers}
            />
          </Grid>
        </Fade>
      );
    });

    const listNewCoproducers = listNew.map((cop) => {
      return (
        <Fade in={showNew} key={cop.originalIndex}>
          <Grid item xs={12} md={6}>
            {cop.customer_id === PROJECT_ELEVAR_ID ? (
              <SolidaritySquadForm
                index={cop.originalIndex}
                coproducer={cop}
                onRemove={() => this.remove(cop.originalIndex)}
                onChange={this.onChange}
              />
            ) : (
              <CoProducerForm
                index={cop.originalIndex}
                coproducer={cop}
                onChangeField={this.onChange}
                onChangeRequiredFields={onChangeRequiredFields}
                onRemove={() => this.remove(cop.originalIndex)}
                isProducer={false}
                onSearchSuccess={this.onSearchSuccess}
                coproducers={listCoproducers}
              />
            )}
          </Grid>
        </Fade>
      );
    });

    const listPendingCoproducers = listPending.map((cop) => {
      return (
        <Fade in={showPending} key={cop.originalIndex}>
          <Grid item xs={12} md={6}>
            <PartnerCardPreview
              index={cop.originalIndex}
              coproducer={cop}
              onChangeField={this.onChange}
              onChangeRequiredFields={onChangeRequiredFields}
              onRemove={() => this.remove(cop.originalIndex)}
              isProducer={true}
              onSearchSuccess={this.onSearchSuccess}
              disabled={true}
              pendingStatus={cop.status}
              coproducers={listCoproducers}
            />
          </Grid>
        </Fade>
      );
    });

    const { canAddCoproducer, coProducerErrorMessage, hasElevarAdded } = this.props;

    return (
      <FormContent
        title='Parceiros do Produto'
        loading={loading}
        action={
          <Tooltip title={coProducerErrorMessage} placement='top'>
            <span>
              <Button variant='outlined' color='primary' onClick={this.add} startIcon={<GroupAddOutlined />} disabled={!canAddCoproducer}>
                Adicionar novo parceiro
              </Button>
            </span>
          </Tooltip>
        }
      >
        <Grid container alignItems='flex-start' justifyContent='space-between' spacing={2}>
          {!hasElevarAdded && (
            <Grid item xs={12}>
              <SolidaritySquadAlert onBtnClick={() => this.addElevar()} />
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid container alignItems='center' justifyContent='space-between' className={classes.filter}>
              <Grid item style={{ paddingRight: 12 }}>
                <strong>Mostrar:</strong>
              </Grid>
              <Grid item>
                <FormControl component='fieldset' fullWidth>
                  <FormGroup aria-label='legend' row>
                    <FormControlLabel
                      labelPlacement='end'
                      control={
                        <Switch
                          color='primary'
                          checked={this.state.showActive}
                          onChange={() => this.setState((prev) => ({ showActive: !prev.showActive }))}
                        />
                      }
                      label='Ativos'
                    />
                    <FormControlLabel
                      labelPlacement='end'
                      control={
                        <Switch color='primary' checked={this.state.showNew} onChange={() => this.setState((prev) => ({ showNew: !prev.showNew }))} />
                      }
                      label='Novos'
                    />
                    <FormControlLabel
                      labelPlacement='end'
                      control={
                        <Switch
                          color='primary'
                          checked={this.state.showPending}
                          onChange={() => this.setState((prev) => ({ showPending: !prev.showPending }))}
                        />
                      }
                      label='Pendentes'
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          {commissionBiggerThanExpected && (
            <Grid item xs={12}>
              <Fade in={true}>
                <Alert severity='error'>
                  <p>O valor total de comissão deve ser {MAX_COMISSION}% somando o valor de comissão de todos os parceiros ativos.</p>
                  <p>
                    Valor atual: <strong>{activeValue}%</strong>
                  </p>
                </Alert>
              </Fade>
            </Grid>
          )}

          {!hasCoproducers && (
            <ListMaterial>
              <span style={{ margin: '0 1rem' }}>Não há parceiros cadastrados</span>
            </ListMaterial>
          )}
          {showActive && hasActive && (
            <>
              <Grid item xs={12} md={12}>
                <h4>Ativos</h4>
              </Grid>
              {listSavedCoproducers}
            </>
          )}
          {showNew && hasNew && (
            <>
              <Grid item xs={12} md={12} ref={this.listNewRef}></Grid>
              {listNewCoproducers}
            </>
          )}
          {showPending && hasPending && (
            <>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <h4>Pendentes</h4>

                <Alert
                  severity='info'
                  action={
                    <Button>
                      <a
                        href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807551969-Como-adicionar-um-Co-Produtor-%C3%93rbita-'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Saiba mais
                      </a>
                    </Button>
                  }
                >
                  <p>
                    As alterações pendentes serão ativas apenas quando todos estiverem com o status: <strong>APROVADO.</strong>
                  </p>
                  <p>Será descartado todos os parceiros pendentes ao editar e salvar uma nova configuração de parceiros. </p>
                </Alert>
              </Grid>
              {listPendingCoproducers}
            </>
          )}
        </Grid>
      </FormContent>
    );
  }
}
const putIndexOnArray = (array: any[]) => {
  return array.map((a, index) => {
    a.originalIndex = index;
    return a;
  });
};

export default styles(withRouter(CoProducer));
